import { useQuery } from "@tanstack/react-query";

import { getFootprintingEmissionFactorsRefrigerants, getFootprintingEmissionFactorsRefrigerantsAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_EMISSION_FACTORS_REFRIGERANTS } from "consts";

export const useGetFootprintingEmissionFactorsRefrigerants = () => {
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFootprintingEmissionFactorsRefrigerantsAdmin : getFootprintingEmissionFactorsRefrigerants;

  return useQuery({
    queryKey: [FOOTPRINTING_EMISSION_FACTORS_REFRIGERANTS],
    queryFn: () => queryFn(),
  });
};
